import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profileListViewItemLeftPart" }
const _hoisted_2 = ["title"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-eye" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "button",
        "data-cy": "cyProfileActionInList",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.invitationProfileActionInList($props.aUserProfile)))
      }, _toDisplayString($setup.t($props.profileActionInListButtonText)), 1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.viewUserProfile($props.aUserProfile.getUPUserId()))),
        title: $setup.t('viewProfileTitle')
      }, _hoisted_4, 8, _hoisted_2)
    ])
  ]))
}